/**
 * Константы для UI компонентов и интерфейса.
 * Часть экспортов (TOAST_POSITIONS, MODAL_*, PAGINATION_*, NAVIGATION_* и др.) зарезервирована для единообразия и будущего использования.
 */


/**
 * Константы для z-index слоев
 */
export const Z_INDEX_CONSTANTS = {
  /** Базовый слой */
  BASE: 0,
  /** Слой навигации */
  NAVIGATION: 1,
  /** Слой выпадающих меню */
  DROPDOWN: 2,
  /** Слой модальных окон */
  MODAL: 50,
  /** Слой уведомлений */
  NOTIFICATION: 100,
  /** Максимальный z-index */
  MAX: 2147483647,
} as const;

// UI_SIZES удалены как избыточные - используются только в одном месте

// LOG_COLORS удалены как избыточные - используются только в одном месте

// FONT_WEIGHTS удалены как избыточные - используются только в одном месте

/**
 * Константы для таблиц
 */
export const TABLE_CONSTANTS = {
  /** Количество элементов на странице по умолчанию */
  DEFAULT_PAGE_SIZE: 10,
  /** Размеры страниц */
  PAGE_SIZES: [5, 10, 20, 50, 100] as const,
  /** Максимальное количество элементов на странице */
  MAX_PAGE_SIZE: 1000,
  /** Высота строки таблицы */
  ROW_HEIGHT: 40, // px
  /** Высота заголовка таблицы */
  HEADER_HEIGHT: 48, // px
  /** Минимальная ширина колонки */
  MIN_COLUMN_WIDTH: 80, // px
  /** Максимальная ширина колонки */
  MAX_COLUMN_WIDTH: 500, // px
} as const;

/**
 * Константы для обложек (cover; нейминг без "banner" из-за AdBlock)
 */
export const BANNER_CONSTANTS = {
  ASPECT_RATIO: 4,
  SIZES: {
    PROFILE_WIDTH: 400,
    PROFILE_HEIGHT: 128,
  },
} as const;

/**
 * Константы для цветов статусов пользователей
 */
export const USER_STATUS_COLORS = {
  /** Онлайн */
  ONLINE: "bg-green-400",
  /** Офлайн */
  OFFLINE: "bg-gray-400",
  /** Играет */
  PLAYING: "bg-blue-400",
  /** Занят */
  BUSY: "bg-red-400",
  /** Отошел */
  AWAY: "bg-yellow-400",
  /** Ищет матч */
  SEARCHING: "bg-purple-400",
  /** Невидимка (виден только себе) */
  INVISIBLE: "bg-gray-400",
} as const;

/**
 * Константы для breakpoints
 */
export const BREAKPOINTS = {
  /** Мобильные устройства */
  MOBILE: 640, // px
  /** Планшеты */
  TABLET: 768, // px
  /** Ноутбуки */
  LAPTOP: 1024, // px
  /** Десктопы */
  DESKTOP: 1280, // px
  /** Большие экраны */
  LARGE: 1536, // px
} as const;

/**
 * Валидирует только критически важные UI константы
 */
function validateCriticalUiConstants(): void {
  // Валидация размеров таблиц (критично для производительности)
  if (TABLE_CONSTANTS.MAX_PAGE_SIZE > 1000) {
    throw new Error(
      "MAX_PAGE_SIZE не должен превышать 1000 для производительности",
    );
  }

  // Валидация breakpoints (критично для responsive дизайна)
  if (BREAKPOINTS.MOBILE >= BREAKPOINTS.TABLET) {
    throw new Error("MOBILE breakpoint должен быть меньше TABLET");
  }

  // Валидация только критически важных UI констант
  // Остальные полагаются на TypeScript типизацию
}

// Запускаем валидацию только критических констант
validateCriticalUiConstants();
